import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Card, Collapse, Grid, Paper, Typography, FormControlLabel, Checkbox
} from "@material-ui/core";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { formatDate, formateMdnNumber, formatDateTime, numberDisplay, maskCreditCardNumber, allowedAttachmentsImages, maskAccountNumber, formatSizeUnits, formatNumberComma, getFormatedDate, saveActivlityLogInfo } from '../../../src/components/Common/Extensions';
import GlobeIcon from './../../assets/img/new images/globe-icon.svg';
import CallIcon from './../../assets/img/new images/call-icon.svg';
import SmsIcon from './../../assets/img/new images/sms-icon.svg';
import RoamingIcon from './../../assets/img/new images/roaming-icon.svg';
import FiggersEligible from './../../assets/img/new images/figgersEligible.svg';
import FiggersACP from './../../assets/img/new images/figgersACP.svg';
import ChangePaymentMethod from './../../assets/img/new images/change-payment-method.svg';
import ChangePlanMethod from './../../assets/img/new images/change-plan.svg';
import FreeInternet from './../../assets/img/new images/free-internet.svg';
import InternetOffers from './../../assets/img/new images/internet-offers.svg';
import NewPackage from './../../assets/img/new images/new-package.svg';
import Rewards from './../../assets/img/new images/rewards.svg';
import ServicesReview from './../../assets/img/new images/service-review.svg';
import Shop from './../../assets/img/new images/shop.svg';
import Edit from './../../assets/img/new images/edit.svg';
import Remove from './../../assets/img/icons/delete-normal.svg';
import Dollar from './../../assets/img/icons/dollar.svg';
import ViewIcon from './../../assets/img/icons/view.svg';
import RefreshIcon from './../../assets/img/icons/refresh.svg';
import WarningCircle from './../../assets/img/icons/warning-circle.svg';
import { PostDataAPI } from '../../Services/APIService';
import { GetUserInfo } from "../../Services/GetUserInfo";
import Tooltip from '@material-ui/core/Tooltip';
import Loader from './../../components/Loader/Loader';
import EmptyGrid from './../../assets/img/emptyGrid.svg';
import OrderChart from './orderchart/OrderChart';
import OrderChartBar from './orderchart/OrderChartBar';
import MessageDialog from './../../components/MessageDialog/MessageDialog';
import { useLocation } from 'react-router-dom';
import RechargeDialog from "./components/recharge/RechargeDialog";
import ChangeShippingAddress from '../prepaid/components/changeShippingAddress/ChangeShippingAddress';//'./components/changeShippingAddress/ChangeShippingAddress';
import UserPlaceholder from "./../../assets/img/action/userPlaceholder.svg";
import EditPen from './../../assets/img/action/penWhite.svg';
import WarningRedTrasp from './../../assets/img/icons/warning-sign-transp.svg';

import ViewAllUsage from './components/viewAllUsage/ViewAllUsage';
import NoRecord from "../../components/NoRecord/NoRecord";
import { withSnackbar } from "./../../components/Message/Alert";
import CCIcon from "./../../assets/img/newSim/cc_icon.png";

import ActiveIcon from './../../assets/img/status/Active.svg';
import Inactive from './../../assets/img/status/Inactive.svg';
import Rejected from './../../assets/img/status/Rejected.svg';
import Suspended from './../../assets/img/status/Suspended.svg';
import PortInCancel from './../../assets/img/status/Port-In-Cancel.svg';
import Disconnected from './../../assets/img/status/Disconnected.svg';
import Hotline from './../../assets/img/status/Hotline.svg';
//styles
import useStyles from "./styles";
import { SelectField } from "../../components/InputField/InputField";
import MonthlyUsageSummary from "../lineManagement/components/monthlyUsageSummary/MonthlyUsageSummary";
import DateFilter from "../lineManagement/components/datefilters/DateFilters"
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import DialogLoader from "../../components/Loader/DialogLoader";
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";

function Dashboard({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [accountCardOpen, setAccountCardOpen] = useState(true);
    const commonAttachments = allowedAttachmentsImages();
    const [isLoading, setIsLoading] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [loginUser, setLoginUser] = useState(user_info.user);
    const [isPrepaid, setIsPrepaid] = useState(user_info.user.isPrepaid);
    const [isPaymentLoaded, setIsPaymentLoaded] = useState(false);
    const [customerOffers, setCustomerOffers] = useState([]);
    const [monthlyUsageSummary, setMonthlyUsageSummary] = useState(false);
    const [dateFilter, setDateFilter] = useState(false);
    const [dialogLoading, setDialogLoading] = useState(false);

    const [selectedDateFilters, setSelectedDateFilter] = useState({ fromDate: '', toDate: '' });

    const [rechargeDialog, setRechargeDialog] = useState(false);

    const [viewAllUsage, setViewAllUsage] = useState(false);
    const [messageDialog, setMessageDialog] = useState(true);

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const location = useLocation();

    const openMessage = () => {
        setMessageDialog(true)
    }

    const closeMessage = () => {
        setMessageDialog(false)
    }

    const handleClose = () => {
        setViewAllUsage(false)
    }
    const showAllUsage = () => {
        logAccountSummaryActivity("Usage Details Modal Opened", "User opened usage details modal");
        setViewAllUsage(true)
    }

    const generateUsageReport = (_filters) => {
        setSelectedDateFilter(prevState => ({
            ...prevState,
            fromDate: _filters.fromDate.toString(),
            toDate: _filters.toDate.toString()

        }))
        setDateFilter(false)
        var params = {
            accountNumber: accountNumber,
            fromDate: getFormatedDate(_filters.fromDate.toString(), 'YYYY-MM-DD') + '',
            toDate: getFormatedDate(_filters.toDate.toString(), 'YYYY-MM-DD') + '',
            searchFilter: 'AccountLevel'
        }

        setIsLoading(true)
        PostDataAPI("telispire/exportMonthlyUsageDetails", params, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data) {
                window.location.assign(result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        })
        //setMonthlyUsageSummary(true)
    }
    const digitalServiceData = [
        { title: "Change Plan", image: ChangePlanMethod },
        { title: "Internet offers", image: InternetOffers },
        { title: "Rewards", image: Rewards },
        { title: "Figgers ACP", image: FiggersACP },
        { title: "Shop", image: Shop },
        { title: "New Packages& offers", image: NewPackage },
        { title: "Change Payment Method", image: ChangePaymentMethod },
        { title: "Services Review", image: ServicesReview },
    ]
    const usageByBillingMonthTypeOptions = [
        { label: "Current Billing Month", value: "1" },
        { label: "Last 3 Billing Months", value: "3" },
        { label: "Last 6 Billing Months", value: "6" }
    ];
    const [userRole, setUserRole] = useState(user_info.user.roleId);
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);
    const logAccountSummaryActivity = (activity, detailText) => {
        saveActivlityLogInfo(
            "Account Summary",
            activity,
            `${detailText} for account ${maskAccountNumber((accountNumber || "").toString())}`,
            accountNumber,
            customerID
        );
    };
    const getUsageBillingMonthLabel = (value) => {
        const selectedOption = usageByBillingMonthTypeOptions.find(item => item.value == value?.toString());
        return selectedOption ? selectedOption.label : `${value} Billing Months`;
    };
    const openRechargeDialog = () => {
        logAccountSummaryActivity("Recharge Modal Opened", "User opened recharge modal");
        setRechargeDialog(true);
    };
    const [selectedCustomer, setSelectedCustomer] = useState({ lstPaymentHistory: [] });
    const [lstUsageSummary, setLstUsageSummary] = useState([]);
    const [addressType, setAddressType] = useState("");
    const [objAddress, setObjAddress] = useState({});
    const [changeShippingAddress, setChangeShippingAddress] = useState(false);
    const getCustomerDetail = () => {

        var obj = { AccountNumber: accountNumber, MDN: '', isPrepaid: isPrepaid, includeDisconnectedLines: true };
        setIsLoading(true);
        PostDataAPI("telispire/getCustomerDetail", obj, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setIsPaymentLoaded(false);
                if (!result.data.objCustomerInfo.shipAddress1 && !result.data.objCustomerInfo.shipAddress2) {
                    result.data.objCustomerInfo.shipAddress1 = result.data.objCustomerInfo.homeAddress1;
                    result.data.objCustomerInfo.shipAddress2 = result.data.objCustomerInfo.homeAddress1;
                    result.data.objCustomerInfo.shipCity = result.data.objCustomerInfo.homeCity;
                    result.data.objCustomerInfo.shipState = result.data.objCustomerInfo.homeState;
                }
                result.data.isSelected = true;

                setSelectedCustomer(result.data);
            }
            else {
                showMessage("Error", "We're currently experiencing a temporary issue retrieving the information you requested. Please try again later.", "error", 3000);
            }
            setIsLoading(false);
        })
    }

    const daysLeft = (targetDate) => {
        // Get the current date
        let currentDate = new Date();

        // Calculate the time difference in milliseconds
        let timeDiff = targetDate.getTime() - currentDate.getTime();

        // Convert the time difference to days
        let daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return daysLeft;
    }

    const getCurrentMonthYear = () => {
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = now.getFullYear();
        return `${month}/${year}`;
    };

    const removeBillingInformation = () => {
        logAccountSummaryActivity("Remove Billing Confirmation Opened", "User opened remove card on file confirmation");

        showActionDialog("Removing the card number will prevent the system from processing any charges on your account. Please update your payment details promptly to avoid any interruption in service.", "confirm", function () {

            var params = {
                accountNumber: accountNumber,
                billingAddress1: selectedCustomer?.objCustomerInfo?.billingAddress1,
                billingAddress2: selectedCustomer?.objCustomerInfo?.billingAddress2,
                billingCity: selectedCustomer?.objCustomerInfo?.billingCity,
                billingState: selectedCustomer?.objCustomerInfo?.billingState,
                billingZip: selectedCustomer?.objCustomerInfo?.billingZip,
                billingName: selectedCustomer?.objCustomerInfo?.billingName,
                creditCardNumber: '',
                creditCardExpiration: getCurrentMonthYear(),
                creditCardExpirationCvv: '',
                creditCardType: selectedCustomer?.objCustomerInfo?.creditCardType,
                
            }
            setIsLoading(true);
            PostDataAPI("telispire/updateBillingAddress", params, true).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {

                    if (result.data) {
                        var existingData = selectedCustomer.objCustomerInfo;
                        existingData.creditCardNumber = params.creditCardNumber;
                        existingData.creditCardExpiration = params.creditCardExpiration;
                        existingData.creditCardExpirationCvv = params.creditCardExpirationCvv;

                        setSelectedCustomer((prevState) => ({
                            ...prevState,
                            objCustomerInfo: existingData
                        }));
                        showMessage("Success", "Billing information removed successfully.", "success", 3000);

                    }
                    else {
                        showMessage("Error", "Failed to remove billing information, please try again or contact to administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }


            })
        });

    }

    const changeAddress = (type) => {
        logAccountSummaryActivity(
            type == "updateBillingAddress" ? "Billing Information Modal Opened" : "Shipping Address Modal Opened",
            type == "updateBillingAddress" ? "User opened billing information modal" : "User opened shipping address modal"
        );

        setAddressType(type);
        if (type == "updateBillingAddress") {
            setObjAddress({
                address1: selectedCustomer?.objCustomerInfo?.billingAddress1,
                address2: selectedCustomer?.objCustomerInfo?.billingAddress2,
                city: selectedCustomer?.objCustomerInfo?.billingCity,
                state: selectedCustomer?.objCustomerInfo?.billingState,
                zip: selectedCustomer?.objCustomerInfo?.billingZip,
                billingName: selectedCustomer?.objCustomerInfo?.billingName,
                creditCardNumber: selectedCustomer?.objCustomerInfo?.creditCardNumber,
                creditCardType: selectedCustomer?.objCustomerInfo?.creditCardType,
                creditCardExpiration: selectedCustomer?.objCustomerInfo?.creditCardExpiration,
                creditCardExpirationCvv: selectedCustomer?.objCustomerInfo?.creditCardExpirationCvv,
            });
        }
        else {
            setObjAddress({
                address1: selectedCustomer?.objCustomerInfo?.shipAddress1,
                address2: selectedCustomer?.objCustomerInfo?.shipAddress2,
                city: selectedCustomer?.objCustomerInfo?.shipCity,
                state: selectedCustomer?.objCustomerInfo?.shipState,
                zip: selectedCustomer?.objCustomerInfo?.shipZip,
                contactName: selectedCustomer?.objCustomerInfo?.shipName,
                phone: selectedCustomer?.objCustomerInfo?.shipPhone,

            });
        }
        setChangeShippingAddress(true);

    }

    const handleChangeAddressSuccessClose = (_address) => {
        var existingData = selectedCustomer.objCustomerInfo;
        if (addressType == "updateBillingAddress") {
            showMessage("Success", "Billing information updated successfully.", "success", 3000);
            existingData.billingAddress1 = _address.address1
            existingData.billingAddress2 = _address.address2
            existingData.billingCity = _address.city;
            existingData.billingState = _address.state;
            existingData.billingZip = _address.zip;
            existingData.billingName = _address.billingName;
            existingData.creditCardNumber = _address.creditCardNumber;
            existingData.creditCardType = _address.creditCardType;
            existingData.creditCardExpiration = _address.creditCardExpiration;
            existingData.creditCardExpirationCvv = _address.creditCardExpirationCvv;

        }
        else {
            showMessage("Success", "Shipping address updated successfully.", "success", 3000);
            existingData.shipAddress1 = _address.address1;
            existingData.shipAddress2 = _address.address2
            existingData.shipCity = _address.city;
            existingData.shipState = _address.state;
            existingData.shipName = _address.contactName;
            existingData.shipPhone = _address.phone;
            existingData.shipZip = _address.zip;
        }
        setSelectedCustomer((prevState) => ({
            ...prevState,
            objCustomerInfo: existingData
        }));
        setChangeShippingAddress(false);
    }

    const getCustomerOffers = () => {
        var obj = { AccountNumber: accountNumber };
        PostDataAPI("fwoffer/loadCustomerOffers", obj, true).then((result) => {
            if (result.success && result.data != null) {
                setCustomerOffers(result.data);
            } else {
                setCustomerOffers([]);
            }
        })
    }

    const redirectTo = (offer) => {
        const link = typeof offer === "string" ? offer : offer?.redirectTo;
        const title = typeof offer === "string" ? "offer" : offer?.title || "offer";
        logAccountSummaryActivity("Offer Opened", `User opened offer ${title}`);
        window.open(link, '_blank');
    }

    const handleRechargeSuccessClose = (_message) => {
        setRechargeDialog(false);
    }
    const [usageSummaryFilter, setUsageSummaryFilter] = useState(1);
    const statusCheckbox = [
        {
            value: '0',
            status: 'Active',
            label: 'Active',
            icon: ActiveIcon,
        },
        {
            value: '0',
            status: 'Inactive',
            label: 'Inactive',
            icon: Inactive,
        },
        {
            value: '0',
            status: 'Suspended',
            label: 'Suspended',
            icon: Suspended,
        },
        {
            value: '0',
            status: 'Disconnected',
            label: 'Disconnected',
            icon: Disconnected,
        },

    ]

    const handleBillingMonthChange = (e) => {
        const { name, value } = e.target;
        if (value) {
            const selectedFilter = parseInt(value);
            logAccountSummaryActivity("Usage Billing Month Filter Changed", `User selected ${getUsageBillingMonthLabel(selectedFilter)} usage filter`);
            handleUsageByBillingMonthChange(selectedFilter);
        }
    }

    const handleUsageByBillingMonthChange = (filter) => {
        setUsageSummaryFilter(filter);
        let isIncludePreviousCycles = filter > 1 ? true : false;

        var obj = { AccountNumber: accountNumber, isIncludePreviousCycles: isIncludePreviousCycles, filter: filter };
        setDialogLoading(true);
        PostDataAPI("telispire/getAccountUsageDetailsForPreviousMonths", obj, true).then((result) => {
            setDialogLoading(false);
            if (result.success && result.data != null && result.data.lstUsageSummary.length > 0) {
                setLstUsageSummary(result.data.lstUsageSummary);
            }
            else {
                setLstUsageSummary([]);
            }

        })

    }

    const [bedgeImage, setBedgeImage] = useState({ file: null, fileToSend: null, fileName: "" });

    const inputFile = useRef(null);

    const uploadFile = () => {
        //logAccountSummaryActivity("Profile Image Picker Opened", "User opened corporate profile image picker");

        inputFile.current.click();
    };

    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setBedgeImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })

        updateImage(e.target.files[0], true);
    }


    const [coverImage, setCoverImage] = useState({ file: null, fileToSend: null, fileName: "" });

    const inputCover = useRef(null);

    const uploadCover = () => {
        //logAccountSummaryActivity("Banner Image Picker Opened", "User opened corporate banner image picker");

        inputCover.current.click();
    };

    function uploadCoverFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setCoverImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })
        updateImage(e.target.files[0], false);

    }

    function updateImage(file, isUpdateProfile) {
        const formData = new FormData();
        formData.append("accountNumber", accountNumber);
        if (isUpdateProfile) {
            formData.append("corporateProfile", file);
        } else {
            formData.append("corporateBanner", file);
        }

        formData.append("IsUpdateProfile", isUpdateProfile);
        setIsLoading(true);
        PostDataAPI("customer/updateCorporateProfile", formData, true, "formData").then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                if (isUpdateProfile) {
                    user_info.user.corporateProfilePath = result.data.corporateProfilePath;
                } else {
                    user_info.user.corporateBannerPath = result.data.corporateBannerPath;
                }

                sessionStorage.removeItem('user_info')
                sessionStorage.setItem('user_info', JSON.stringify(user_info))
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        })
    }
    const toggleAccountCard = () => {
        const nextOpen = !accountCardOpen;
        logAccountSummaryActivity("Account Summary Section Toggled", `User ${nextOpen ? "expanded" : "collapsed"} account summary section`);
        setAccountCardOpen(nextOpen);
    };

    useEffect(() => {
        debugger
        console.log(loginUser)
        if (accountNumber > 0) {
            handleUsageByBillingMonthChange(1)
            getCustomerDetail();
            getCustomerOffers();
        }

    }, [])
    //line to show package expiry dialog
    //{
    //    messageDialog && daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) <= 5 && daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) >= 1 ?
    //    <MessageDialog rechargeBtn={true} icon={WarningRedTrasp} iconSize={"70px"} messageText={"Your package is expiring on " + formatDate(selectedCustomer?.objCustomerInfo?.packageExpirationDate) + " Recharge on time to continue enjoying uninterrupted service."} openMessage={openMessage} closeMessage={closeMessage}></MessageDialog>
    //    : messageDialog && daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) < 1 ?
    //        <MessageDialog rechargeBtn={true} icon={WarningRedTrasp} iconSize={"70px"} messageText="Your mobile package has expired. To restore service, please renew your package immediately." openMessage={openMessage} closeMessage={closeMessage}></MessageDialog>
    //        : ''
    //}
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}



            <div className={classes.appBarSpacer} />

            {window.isIpadView ? '' : <div className={classes.header}>
                <Typography component="h2">Welcome  {selectedCustomer?.objCustomerInfo?.fullName}</Typography>
                <div className={classes.floatRight}>
                    <h4 className={classes.accountType}>Account Type: {isPrepaid ? 'Prepaid' : 'Postpaid'} </h4>
                </div>
            </div>}

            <Grid className={classes.container}>

                <Grid container>
                    {loginUser.userType == "corporate_user" ? <>
                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                            <div className={classes.PRofileTop}>
                                <div className={classes.CoverImg}>
                                    <div className={classes.CoverSec}>

                                        <div className={classes.coverImg}>
                                            {coverImage.file || loginUser.corporateBannerPath ?
                                                <>
                                                    <img src={coverImage.file ? coverImage.file : '.' + loginUser.corporateBannerPath} />
                                                </>
                                                : <div style={{ backgroundImage: 'URL(' + UserPlaceholder + ')' }}></div>
                                            }
                                            <img className={classes.CoverEditICon} src={EditPen} onClick={uploadCover} />
                                            <form>
                                                <div>
                                                    <input type="file" id="fileUploadField" ref={inputCover} className={classes.inputFile} onChange={uploadCoverFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                                <div className={classes.whiteBox}>
                                    <div className={classes.profileImg}>
                                        {bedgeImage.file || loginUser.corporateProfilePath ?
                                            <>
                                                <img src={bedgeImage.file ? bedgeImage.file : '.' + loginUser.corporateProfilePath} />
                                            </>

                                            : <img src={UserPlaceholder} style={{ objectFit: 'contain' }} />

                                        }
                                        <img className={classes.EditICon} src={EditPen} onClick={uploadFile} />
                                        <form>
                                            <div>
                                                <input type="file" id="fileUploadField" ref={inputFile} className={classes.inputFile} onChange={uploadSingleFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </Grid>
                    </> :
                        ''}

                    {window.isIpadView ?
                        <div className={classes.mobAccountInformation}>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item sm={6} xs={6}>
                                    <div className={classes.mobUserAccound}>
                                        <h2>{selectedCustomer?.objCustomerInfo?.fullName}</h2>
                                        <p> {selectedCustomer?.objCustomerInfo?.accountNumber} </p>
                                    </div>

                                </Grid>
                                <Grid item sm={6} xs={6}>

                                    {selectedCustomer?.objCustomerInfo?.packageExpirationDate ?
                                        <>
                                            <div className={classes.mobAccountDetails}>
                                                {/* <img src={WarningCircle} /> */}
                                                <div>
                                                    <h4> Expiration Date: </h4>
                                                    {formatDate(selectedCustomer?.objCustomerInfo?.packageExpirationDate)}
                                                </div>
                                            </div>
                                        </>

                                        : <>  <div className={classes.mobAccountDetails}>
                                            {/* <img src={WarningCircle} /> */}
                                            <div className={classes.expiryDatePast}>  Account Status: Inactive</div>
                                        </div>  </>}
                                </Grid>
                            </Grid>
                            {userRole != 3 && isPrepaid ? <Grid container alignItems="center" justifyContent="center" spacing={1}>
                                <Button className={classes.rechargeBtn} onClick={openRechargeDialog}>Recharge Now</Button>
                            </Grid> : ''}

                        </div> :
                        <Collapse in={accountCardOpen} collapsedSize={65} className={classes.accountPaperCollapse}>
                            <div className={classes.accountPaper} >
                                <div className={classes.accountCardHeader}>
                                    <div className={classes.accountCardHeaderTitle}>
                                        {/* <Typography className={classes.accountCardMember}>Customer : {maskAccountNumber(selectedCustomer?.objCustomerInfo?.accountNumber)} <span className={classes.accountCardOrganisationName}> - {selectedCustomer?.objCustomerInfo?.fullName}</span></Typography> */}
                                        <Typography className={classes.sectionHeading}><span>  {selectedCustomer?.objCustomerInfo?.fullName || <Skeleton count={1} />}</span></Typography>

                                    </div>
                                    <div className={classes.flexBtn}>

                                        {
                                            selectedCustomer?.objCustomerInfo?.packageExpirationDate ?
                                                <div className={`
                                                    ${selectedCustomer?.objCustomerInfo?.packageExpirationDate && new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate) > new Date() ? classes.expiryDate : classes.expiryDatePast}
                                                    ${daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) <= 5 ? classes.expiryDateRed : ''}
                                                    ${daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) < 15 && daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) > 5 ? classes.expiryDateYellow : ''}
                                                    ${daysLeft(new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate)) > 15 ? classes.expiryDateGreen : ''}`
                                                }>
                                                    <b>Expiration Date </b> {': ' + formatDate(selectedCustomer?.objCustomerInfo?.packageExpirationDate)}
                                                </div>
                                                : '' /*new Date(selectedCustomer?.objCustomerInfo?.packageExpirationDate) < new Date() ? <div className={classes.expiryDatePast}>  Account Status: Inactive</div>

                                                    : ''*/}
                                        {userRole != 3 && isPrepaid ? <Button className={classes.changeBtn} onClick={openRechargeDialog}>
                                            <img src={Dollar} /> &nbsp; Recharge
                                        </Button> : ''}

                                        <Button
                                            size="small"
                                            className={classes.closeButton}
                                            startIcon={accountCardOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            onClick={toggleAccountCard}
                                        >
                                        </Button>
                                    </div>

                                </div>

                                <div className={classes.accountCardContainer} style={{ display: window.isMobileView || window.isIpadView ? 'block' : '' }}>
                                    <div className={classes.accountSection}>
                                        {selectedCustomer?.objCustomerInfo ?
                                            <ul className={classes.accountList}>
                                                <li>
                                                    <Typography className={classes.accountLabel}>Account #:</Typography>
                                                    <Typography className={classes.accountValue}>{maskAccountNumber(selectedCustomer?.objCustomerInfo?.accountNumber)}</Typography>
                                                </li>
                                                <li>
                                                    <Typography className={classes.accountLabel}>Date Created:</Typography>
                                                    <Typography className={classes.accountValue}>{formatDate(selectedCustomer?.objCustomerInfo?.dateCreated)}</Typography>
                                                </li>
                                                {/*<li>*/}
                                                {/*    <Typography className={classes.accountLabel}>Billing Cycle</Typography>*/}
                                                {/*    <Typography className={classes.accountValue}>{selectedCustomer?.objCustomerInfo?.billingCycle}</Typography>*/}
                                                {/*</li>*/}
                                                {/* <li>
                                                    <Typography className={classes.accountLabel}>Total Monthly Charges:</Typography>
                                                    <Typography className={classes.accountValue}>{selectedCustomer?.objCustomerInfo?.monthlyCharges}</Typography>
                                                </li> */}

                                                <li>
                                                    <Typography className={classes.accountLabel}>Email:</Typography>
                                                    <Typography className={classes.accountValue}>{selectedCustomer?.objCustomerInfo?.email}</Typography>
                                                </li>
                                                <li>
                                                    <Typography className={classes.accountLabel}>Contact Number:</Typography>
                                                    <Typography className={classes.accountValue}>{formateMdnNumber(selectedCustomer?.objCustomerInfo?.homePhone)}</Typography>
                                                </li>

                                                <li>
                                                    <Typography className={classes.accountLabel}>Billing Cycle:</Typography>
                                                    <Typography className={classes.accountValue}>{selectedCustomer?.objCustomerInfo?.billingCycle}</Typography>
                                                </li>

                                                {!isPaymentLoaded ? '' :
                                                    <>
                                                        <li>
                                                            <Typography className={classes.accountLabel}>Next Billing Date:</Typography>
                                                            <Typography className={classes.accountValue}>{formatDate(selectedCustomer?.objCustomerInfo?.dueDate)}</Typography>
                                                        </li>

                                                        <li>
                                                            <Typography className={classes.accountLabel}>Total Balance:</Typography>
                                                            <Typography className={classes.accountValue}>{numberDisplay(selectedCustomer?.objCustomerInfo?.currentBalance, 0, 0, '')}</Typography>
                                                        </li>
                                                    </>
                                                }

                                                {/*{!isPaymentLoaded ? '' :*/}
                                                {/*    <>*/}
                                                {/*        <li>*/}
                                                {/*            <Typography className={classes.accountLabel}>Payment Method:</Typography>*/}
                                                {/*            <Typography className={classes.accountValue}></Typography>*/}
                                                {/*        </li>*/}
                                                {/*        <li>*/}
                                                {/*            <Typography className={classes.accountLabel}>Last Payment:</Typography>*/}
                                                {/*            <Typography className={classes.accountValue}>{numberDisplay(selectedCustomer?.objCustomerInfo?.lastPaymentAmount,0,0,'')}</Typography>*/}
                                                {/*        </li>*/}
                                                {/*        <li>*/}
                                                {/*            <Typography className={classes.accountLabel}>Past Due Balance:</Typography>*/}
                                                {/*            <Typography className={classes.accountValue}></Typography>*/}
                                                {/*        </li>*/}
                                                {/*    </>*/}
                                                {/*}*/}

                                                {/*{isPaymentLoaded == true ? '' :*/}
                                                {/*    <li>*/}
                                                {/*        <Typography className={classes.showMore} onClick={getLastPayment}>Show more...</Typography>*/}
                                                {/*    </li>*/}
                                                {/*}*/}
                                            </ul> :
                                            <Skeleton count={6} />
                                        }
                                    </div>

                                    <div style={{ marginLeft: window.isWidth1600 ? '' : 'auto' }}>
                                        <Grid container className={classes.statusBoxContainer}>

                                            <div className="statusBoxesSmall Active flowColumns">
                                                <h4>Active</h4>
                                                <h2>{formatNumberComma(selectedCustomer?.objCustomerInfo?.activeLineCount ? selectedCustomer?.objCustomerInfo?.activeLineCount : 0)}</h2>
                                            </div>

                                            <div className="statusBoxesSmall Inactive flowColumns">
                                                <h4>Inactive</h4>
                                                <h2>{formatNumberComma(selectedCustomer?.objCustomerInfo?.inactiveLineCount ? selectedCustomer?.objCustomerInfo?.inactiveLineCount : 0)}</h2>
                                            </div>

                                            <div className="statusBoxesSmall Suspended flowColumns">
                                                <h4>Suspended</h4>
                                                <h2>{formatNumberComma(selectedCustomer?.objCustomerInfo?.suspendedLineCount ? selectedCustomer?.objCustomerInfo?.suspendedLineCount : 0)}</h2>
                                            </div>

                                            <div className="statusBoxesSmall Disconnected flowColumns">
                                                <h4>Disconnected</h4>
                                                <h2>{formatNumberComma(selectedCustomer?.objCustomerInfo?.disconnectedLineCount ? selectedCustomer?.objCustomerInfo?.disconnectedLineCount : 0)}</h2>
                                            </div>

                                            {/*{statusCheckbox.map((item, i) => (*/}
                                            {/*    <>*/}
                                            {/*        <FormControlLabel*/}
                                            {/*            className={classes.checkBoxFormLabel}*/}
                                            {/*            control={*/}
                                            {/*                <Checkbox*/}
                                            {/*                    name="checkedB"*/}
                                            {/*                    color="primary"*/}
                                            {/*                    className={classes.checkBoxBtn}*/}
                                            {/*                    disabled={true}*/}

                                            {/*                />*/}
                                            {/*            }*/}
                                            {/*            label={<>*/}
                                            {/*                <div className={item.status == "Active" ? "statusBoxesSmall Active" :*/}
                                            {/*                    item.status == "Inactive" ? "statusBoxesSmall Inactive" :*/}
                                            {/*                        item.status == "Suspended" ? "statusBoxesSmall Suspended" :*/}
                                            {/*                            item.status == "Disconnected" ? "statusBoxesSmall Disconnected" :*/}
                                            {/*                                item.status == "Hotlined" ? "statusBoxesSmall Hotline" :*/}
                                            {/*                                    item.status == "Rejected" ? "statusBoxesSmall Rejected" :*/}
                                            {/*                                        item.status == "PortCancelled" ? "statusBoxesSmall Port-In-Cancel" : ''*/}


                                            {/*                }*/}
                                            {/*                >*/}
                                            {/*                    <div className={classes.statusBoxContent}>*/}
                                            {/*                        <h5>{item.label}</h5>*/}
                                            {/*                        <h2>{selectedCustomer?.lstWireless?.filter(t => t.status == item.status).length}</h2>*/}
                                            {/*                    </div>*/}
                                            {/*                </div>*/}
                                            {/*            </>}*/}
                                            {/*        />*/}
                                            {/*    </>*/}
                                            {/*))}*/}




                                        </Grid>
                                    </div>
                                    <div className={classes.accountSubCardSection}>
                                        <div className={classes.accountHomeSection}>
                                            <Typography className={classes.accountHomeTitle}>Card on File
                                                <div style={{ marginLeft: 'auto' }}>

                                                    {selectedCustomer?.objCustomerInfo?.creditCardNumber ? <span onClick={() => removeBillingInformation()} className={classes.changeLink}>
                                                        <Tooltip title="Remove Billing Information"><img src={Remove} alt='Remove Billing Information' /></Tooltip>
                                                    </span> : ''}

                                                    <span onClick={() => changeAddress("updateBillingAddress")} className={classes.changeLink}>
                                                        <Tooltip title="Edit Billing Information"><img src={Edit} alt="Edit Billing Information" /></Tooltip>
                                                    </span>

                                                </div>
                                            </Typography>
                                            {selectedCustomer?.objCustomerInfo?.billingAddress1 ? <Typography className={classes.accountHomeSubTitle}> {selectedCustomer?.objCustomerInfo?.billingAddress1 || <Skeleton />} </Typography> : ''}
                                            {selectedCustomer?.objCustomerInfo?.billingAddress2 ? <Typography className={classes.accountHomeSubTitle}> {selectedCustomer?.objCustomerInfo?.billingAddress2 || <Skeleton />} </Typography> : ''}

                                            {selectedCustomer?.objCustomerInfo?.billingAddress1 ? '' :
                                                <Typography className={classes.accountAddress}>
                                                    <> <img src={EmptyGrid} className={classes.addressEmptyBox} />  </>
                                                </Typography>
                                            }

                                            <Typography className={classes.accountAddress}>
                                                {selectedCustomer?.objCustomerInfo?.billingCity ? selectedCustomer?.objCustomerInfo?.billingCity + ', ' : ''}
                                                {selectedCustomer?.objCustomerInfo?.billingState} {selectedCustomer?.objCustomerInfo?.billingZip ? selectedCustomer?.objCustomerInfo?.billingZip : ''}
                                            </Typography>
                                            {selectedCustomer?.objCustomerInfo?.creditCardNumber ?
                                                <Typography className={classes.accountHomeAddress}><img src={CCIcon} style={{ maxWidth: "35px" }} alt="Credit Card"></img>{maskCreditCardNumber(selectedCustomer?.objCustomerInfo?.creditCardNumber)}</Typography>
                                                : ''}
                                            {/*<Typography className={classes.accountHomeAddress}>Contact: {formateMdnNumber(selectedCustomer?.objCustomerInfo?.homePhone?.homePhone)}</Typography>*/}
                                        </div>
                                        <div className={classes.accountBillingSection}>
                                            <Typography className={classes.accountHomeTitle}>Shipping Address <span onClick={() => changeAddress("updateShipAddress")} className={classes.changeLink}>
                                                <img src={Edit} />
                                            </span></Typography>
                                            {/*<Typography className={classes.accountHomeSubTitle}>{selectedCustomer?.objCustomerInfo?.shipName}</Typography> */}

                                            {selectedCustomer?.objCustomerInfo?.shipAddress1 ?
                                                <Typography className={classes.accountHomeSubTitle}>{selectedCustomer?.objCustomerInfo?.shipAddress1} </Typography> : ''}

                                            {selectedCustomer?.objCustomerInfo?.shipAddress2 ?
                                                <Typography className={classes.accountHomeSubTitle}>{selectedCustomer?.objCustomerInfo?.shipAddress2} </Typography> : ''}


                                            {selectedCustomer?.objCustomerInfo?.shipAddress1 ? '' :
                                                <Typography className={classes.accountAddress}>
                                                    <>
                                                        <img src={EmptyGrid} className={classes.addressEmptyBox} />  </>
                                                </Typography>}


                                            <Typography className={classes.accountAddress}>
                                                {selectedCustomer?.objCustomerInfo?.shipCity ? selectedCustomer?.objCustomerInfo?.shipCity + ', ' : ''}
                                                {selectedCustomer?.objCustomerInfo?.shipState} {selectedCustomer?.objCustomerInfo?.shipZip ? selectedCustomer?.objCustomerInfo?.shipZip : ''}
                                            </Typography>
                                            {/* {selectedCustomer?.objCustomerInfo ? <Typography className={classes.accountHomeAddress}>{selectedCustomer?.objCustomerInfo?.shipPhone ?
                                                'Contact : ' + formateMdnNumber(selectedCustomer?.objCustomerInfo?.shipPhone) : 'Contact :'}
                                            </Typography> : ''} */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    }


                    <Grid item lg={12} sm={12} md={12} xs={12}>

                        <Grid container spacing={1}>
                            <Grid item lg={12} sm={12} md={12} xs={12}>


                                <Grid container justifyContent="space-between">
                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        {/* <Typography className={classes.sectionHeading}>Usages <span style={{ fontSize: '15px', fontWeight: 400 }}>Last 4 billing months</span></Typography> */}
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={12} className={classes.rightContainer}>
                                        {/* <div className={classes.rightContent}>



                                                    <SelectField
                                                        size="small"
                                                        native
                                                        name="usageByBillingMonthType"
                                                        value={usageSummaryFilter}
                                                        defaultValue={"1"}
                                                        onChange={handleUsageByBillingMonthChange}
                                                        options={usageByBillingMonthTypeOptions}>
                                                        
                                                    </SelectField>
                                                    {selectedCustomer?.objCustomerInfo?.lastUpdatedDate ?
                                                        <>
                                                            <Typography className="paperTime">{`Last updated: ${formatDateTime(selectedCustomer?.objCustomerInfo?.lastUpdatedDate)}`}</Typography>
                                                            <img src={RefreshIcon} alt="refresh" />
                                                        </>
                                                        : ''}


                                                    <Button
                                                        name="view"
                                                        className={classes.viewAllButton}
                                                        onClick={() => showAllUsage()}
                                                        startIcon={<img src={ViewIcon} alt="view" />}>
                                                        Usage Details
                                                    </Button>
                                                </div> */}
                                    </Grid>


                                </Grid>


                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={12} lg={6} order={1} className={classes.column1}>
                                <Typography className={classes.sectionHeading}>Usages <span style={{ fontSize: '15px', fontWeight: 400 }}>Last 4 billing months</span></Typography>

                                <Paper className={classes.chartpaper} style={{ padding: '0px' }}>

                                    <div className={classes.chartTop}>
                                        <span><span className={classes.internetSq}></span>  Internet (MB) </span>
                                        <span><span className={classes.CallSq}></span> Calls</span>
                                        <span><span className={classes.SMSSq}></span> SMS</span>
                                        <span><span className={classes.roamingSq}></span> International</span>
                                    </div>

                                    {/* <OrderChart></OrderChart> */}

                                    <OrderChartBar></OrderChartBar>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} sm={12} lg={6} order={0} className={classes.column2}>
                                <div className={classes.rightContent}>

                                    {window.isMobile425 ?
                                        <Tooltip title="Usage Report">
                                            <Button
                                                name="view"
                                                className={classes.viewAllButtonDisable}
                                                //onClick={() => setDateFilter(true)}
                                                isDisabled={true}
                                            >
                                                Usage Report
                                            </Button>
                                        </Tooltip>
                                        :
                                        <Button
                                            name="view"
                                            className={classes.viewAllButtonDisable}
                                            //  onClick={() => setDateFilter(true)}
                                            isDisabled={true}
                                            startIcon={<img src={ViewIcon} alt="view" style={{ margin: '0' }} />}>
                                            Usage Report
                                        </Button>
                                    }


                                    {/*<Typography className={classes.sectionHeading}> <span style={{ fontSize: '15px', fontWeight: 400, marginLeft: '10px' }}>Current billing month</span></Typography>*/}
                                    <SelectField
                                        size="small"
                                        native
                                        name="usageByBillingMonthType"
                                        className={classes.selectBaseInput}
                                        value={usageSummaryFilter}
                                        defaultValue={"1"}
                                        onChange={handleBillingMonthChange}
                                        options={usageByBillingMonthTypeOptions}>

                                    </SelectField>
                                    {selectedCustomer?.objCustomerInfo?.lastUpdatedDate ?
                                        <>
                                            <Typography className="paperTime">{`Last updated: ${formatDateTime(selectedCustomer?.objCustomerInfo?.lastUpdatedDate)}`}</Typography>
                                            <img src={RefreshIcon} alt="refresh" />
                                        </>
                                        : ''}
                                    {window.isMobile425 ?
                                        <Tooltip title="Usage Details">
                                            <Button
                                                name="view"
                                                className={classes.viewAllButton}
                                                onClick={() => showAllUsage()}
                                            >
                                                Usage Details
                                            </Button>
                                        </Tooltip>
                                        :
                                        <Button
                                            name="view"
                                            className={classes.viewAllButton}
                                            onClick={() => showAllUsage()}
                                            startIcon={<img src={ViewIcon} alt="view" />}>
                                            Usage Details
                                        </Button>
                                    }
                                </div>
                                <div className={classes.cardContainer}>
                                    {dialogLoading ?
                                        <Grid container spacing={1}>
                                            <Grid item sm={12} xs={12} lg={12}>
                                                <Paper className={classes.chartpaper} style={{ padding: '0px' }}> <DialogLoader nobg={true} />
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                        :
                                        <Grid container spacing={1}>
                                            <Grid item sm={6} xs={6} lg={6}>

                                                <Card className={classes.usageCard}>

                                                    <>
                                                        <img src={GlobeIcon} alt="usage" className="cardImage" />
                                                        <Typography className="cardCount">{lstUsageSummary && lstUsageSummary.length > 0 ? formatSizeUnits(lstUsageSummary.reduce((acc, curr) => acc + curr.internetUsage, 0)).toLocaleString() : '0'}</Typography>
                                                        <Typography className="cardUnit">GB's</Typography>
                                                        {/* {window.isIpadView ? '' : <Typography className="cardUsage">Usage</Typography>} */}
                                                        <Typography className="cardTitle">Data</Typography>
                                                    </>

                                                </Card>
                                            </Grid>
                                            <Grid item sm={6} xs={6} lg={6}>
                                                <Card className={classes.usageCard}>

                                                    <>
                                                        <img src={CallIcon} alt="usage" className="cardImage" />
                                                        <Typography className="cardCount">{lstUsageSummary && lstUsageSummary.length > 0 ? numberDisplay(lstUsageSummary.reduce((acc, curr) => acc + curr.voiceMinutes, 0), 0, 0, 0).toLocaleString() : '0'}</Typography>
                                                        <Typography className="cardUnit">Minutes</Typography>
                                                        {/* {window.isIpadView ? '' : <Typography className="cardUsage">Usage</Typography>} */}
                                                        <Typography className="cardTitle">Talk</Typography>
                                                    </>

                                                </Card>
                                            </Grid>
                                            <Grid item sm={6} xs={6} lg={6}>
                                                <Card className={classes.usageCard}>

                                                    <>
                                                        <img src={SmsIcon} alt="usage" className="cardImage" />
                                                        <Typography className="cardCount">{lstUsageSummary && lstUsageSummary.length > 0 ? numberDisplay(lstUsageSummary.reduce((acc, curr) => acc + curr.sMSMessages, 0), 0, 0, 0).toLocaleString() : '0'}</Typography>
                                                        <Typography className="cardUnit">SMS</Typography>
                                                        {/* {window.isIpadView ? '' : <Typography className="cardUsage">Usage</Typography>} */}
                                                        <Typography className="cardTitle">Text</Typography>
                                                    </>

                                                </Card>
                                            </Grid>
                                            <Grid item sm={6} xs={6} lg={6}>
                                                <Card className={classes.usageCard}>

                                                    <>
                                                        <img src={RoamingIcon} alt="usage" className="cardImage" />
                                                        <Typography className="cardCount">{lstUsageSummary && lstUsageSummary.length > 0 ? numberDisplay(lstUsageSummary.reduce((acc, curr) => acc + curr.roamingMinutes, 0), 0, 0, 0).toLocaleString() : '0'}</Typography>
                                                        <Typography className="cardUnit">Minutes</Typography>
                                                        {/* {window.isIpadView ? '' : <Typography className="cardUsage">Usage</Typography>} */}
                                                        <Typography className="cardTitle">International</Typography>
                                                    </>

                                                </Card>
                                            </Grid>
                                        </Grid>}
                                </div>
                            </Grid>

                        </Grid>


                    </Grid>


                    {/*<Grid item lg={12}>*/}
                    {/*    <Paper className={classes.digitalServicePaper}>*/}
                    {/*        <Grid container>*/}
                    {/*            <Grid item lg={12}>*/}
                    {/*                <Grid container justifyContent="space-between">*/}
                    {/*                    <Grid lg={6}>*/}
                    {/*                        <Typography className="paperTitle">Digital Services</Typography>*/}
                    {/*                    </Grid>*/}
                    {/*                    */}{/* <Grid lg={6}>*/}{/*
                    */}{/*                                <Typography className="paperTime">{`Last updated: March 21,2023 12:36 am `}</Typography>*/}{/*
                    */}{/*                            </Grid> */}
                    {/*                </Grid>*/}

                    {/*            </Grid>*/}
                    {/*            <div className={classes.digitalCardContainer}>*/}
                    {/*                {*/}
                    {/*                    digitalServiceData.map((cardItem, index) => {*/}
                    {/*                        return <div className={classes.digitalServiceCard}>*/}
                    {/*                            <img src={cardItem.image} alt="usage" className="cardImage" />*/}
                    {/*                            <Typography className="cardTitle">{cardItem.title}</Typography>*/}
                    {/*                        </div>*/}
                    {/*                    })*/}
                    {/*                }*/}
                    {/*            </div>*/}
                    {/*        </Grid>*/}
                    {/*    </Paper>*/}
                    {/*</Grid>*/}

                    <Grid item sm={12} xs={12} lg={12}>

                        {customerOffers.length > 0 ?

                            <div className={classes.figgersContainer}>
                                {
                                    customerOffers.map((cardItem, index) => {
                                        console.log("." + cardItem?.photoPath);
                                        if (cardItem.offerType == 'text_image') {
                                            return <Card className={classes.figgersEligibleCard} onClick={() => redirectTo(cardItem)}>
                                                <div>
                                                    <Typography className='figgersCardTitle'>{cardItem.title}</Typography>
                                                    <Typography className='figgersCardDesc'>{cardItem.description}</Typography>
                                                </div>
                                                {(cardItem.photoPath && cardItem.photoPath != '') ? <img src={"." + cardItem?.photoPath} alt="figgers eligible" /> : ''}
                                            </Card>
                                        } else if (cardItem.offerType == 'text') {
                                            return <Card className={classes.figgersEligibleCard} onClick={() => redirectTo(cardItem)}>
                                                <div>
                                                    <Typography className='figgersCardTitle'>{cardItem.title}</Typography>
                                                    <Typography className='figgersCardDesc'>{cardItem.description}</Typography>
                                                </div>
                                            </Card>
                                        } else if (cardItem.offerType == 'image') {
                                            return <div>
                                                {(cardItem.photoPath && cardItem.photoPath != '') ? <a href={cardItem.redirectTo} target="_blank" onClick={() => logAccountSummaryActivity("Offer Opened", `User opened offer ${cardItem.title || "offer"}`)}><img className={classes.figgersEligibleCard} src={"." + cardItem?.photoPath} alt={cardItem.title} /></a> : ''}
                                            </div>
                                        } else {
                                            return '';
                                        }

                                    })
                                }

                            </div>
                            :
                            <div className={classes.offersContainer}>
                                <Typography className="paperTitle">Offers</Typography>
                                <NoRecord Icon={true} message="No Offer found"></NoRecord>
                            </div>
                        }

                    </Grid>

                </Grid>

            </Grid >

            {
                changeShippingAddress ?
                    <ChangeShippingAddress
                        dialogOpenClose={changeShippingAddress}
                        handleClose={() => { setChangeShippingAddress(false) }}
                        handleSuccessClose={handleChangeAddressSuccessClose}
                        addressType={addressType}
                        accountNumber={accountNumber}
                        objAddress={objAddress}
                    ></ChangeShippingAddress>
                    : null
            }

            {viewAllUsage ?
                <ViewAllUsage
                    dialogOpenClose={viewAllUsage}
                    handleClose={handleClose}
                    accountNumber={accountNumber}
                    filter={usageSummaryFilter}>
                </ViewAllUsage> : ''
            }

            {rechargeDialog ?
                <RechargeDialog dialogOpenClose={rechargeDialog}
                    userData={selectedCustomer?.objCustomerInfo}
                    handleSuccessClose={handleRechargeSuccessClose}
                    handleClose={() => { setRechargeDialog(false) }}
                /> : ''
            }

            {
                monthlyUsageSummary ?
                    <MonthlyUsageSummary
                        dialogOpenClose={monthlyUsageSummary}
                        handleClose={() => setMonthlyUsageSummary(false)}
                        accountNumber={accountNumber}
                        dateFilters={selectedDateFilters}
                        searchFilter={'AccountLevel'}
                    ></MonthlyUsageSummary> : null
            }

            {
                dateFilter ?
                    <DateFilter generateReport={generateUsageReport} dialogOpenClose={dateFilter}
                        handleClose={() => setDateFilter(false)}></DateFilter> : null
            }

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )
}
export default withSnackbar(Dashboard);
